app.views.preferences = app.views.base.extend({
  childEvents: {
    'click [data-profile-confirmation]': 'showModalSpinners',
    'click [data-update-contact-preferences]': 'showSpinners',
    'click [data-phone-preference]': 'toggleContactPreferences',
    'click [data-sms-preference]': 'toggleContactPreferences',
    'click [data-email-preference]': 'toggleContactPreferences',
    'click [data-mail-preference]': 'toggleContactPreferences',
    'click [data-regulatory-notice]': 'updateRegulatoryNotice',
    'click [data-marketing-preference-channel]': 'toggleMarketingPreferenceChannel',
    'click [data-special-preference-option]': 'toggleSpecialPreferences',
    'click [data-update-marketing-preferences]': 'showSpinners',
    'click [data-site-navigation] a': 'showMarketingPreferencesSaveWarningModal',
    'click [data-link]': 'showMarketingPreferencesSaveWarningModal'
  },
  attr: {
    updatecontactpreferences: 'data-update-contact-preferences',
    regulatoryNoticeUpdate: 'data-regulatory-notice',
    regulatoryNotice: 'data-regulatory-notice-info',
    noPreference: 'data-no-preference-warning',
    contactPreferences: 'data-contact-preferences',
    specialPreferenceOption: 'data-special-preference-option',
    disabled: 'disabled',
    updateMarketingPreferences: 'data-update-marketing-preferences',
    marketingPreferencesChanged: 'data-marketing-preferenes-changed'
  },
  classes: {
    active: 'active',
    updated: 'updated',
    disabled: 'disabled',
    contactPreference: 'contact-preference',
    formSpinner: 'form-spinner',
    pageSpinner: 'page-spinner'
  },
  /**
   * Initialise Preferences View Listener
   * @public
   * @constructor
   */

  init: function init() {},
  showModalSpinners: function showModalSpinners() {
    var container = '.modal';
    var spinner = $(container).find('.' + this.classes.formSpinner);
    if (spinner) {
      spinner.show();
    }
  },
  showSpinners: function showSpinners() {
    var spinner = $('.' + this.classes.pageSpinner);
    if (spinner) {
      spinner.show();
    }
  },
  toggleContactPreferences: function toggleContactPreferences(e) {
    var preference = $(e.currentTarget);
    if (preference.hasClass(this.classes.active) && preference.hasClass(this.classes.updated)) {
      preference.removeClass(this.classes.updated);
      preference.parent('.' + this.classes.contactPreference).find('input').val('true');
    } else if (preference.hasClass(this.classes.active)) {
      preference.addClass(this.classes.updated);
      preference.parent('.' + this.classes.contactPreference).find('input').val('false');
    } else if (preference.hasClass(this.classes.updated)) {
      preference.removeClass(this.classes.updated);
      preference.parent('.' + this.classes.contactPreference).find('input').val('false');
    } else {
      preference.addClass(this.classes.updated);
      preference.parent('.' + this.classes.contactPreference).find('input').val('true');
    }
    var contactPreferencesActivateOrAdded = $('[' + this.attr.contactPreferences + ']').find('.contact-preference input[value="true"]');
    if (!contactPreferencesActivateOrAdded.length) {
      $('[' + this.attr.noPreference + ']').show();
    } else {
      $('[' + this.attr.noPreference + ']').hide();
    }
    $('[' + this.attr.updatecontactpreferences + ']').removeClass(this.classes.disabled);
    $('[' + this.attr.updatecontactpreferences + ']').removeAttr(this.classes.disabled);
  },
  updateRegulatoryNotice: function updateRegulatoryNotice(e) {
    var checkbox = $(e.currentTarget);
    if (checkbox.is(':checked')) {
      checkbox.val('true');
      $('[' + this.attr.regulatoryNotice + ']').show();
    } else {
      checkbox.val('false');
      $('[' + this.attr.regulatoryNotice + ']').hide();
    }
    $('[' + this.attr.updatecontactpreferences + ']').removeClass(this.classes.disabled);
    $('[' + this.attr.updatecontactpreferences + ']').removeAttr(this.attr.disabled);
  },
  toggleMarketingPreferenceChannel: function toggleMarketingPreferenceChannel(e) {
    $('[' + this.attr.updateMarketingPreferences + ']').removeClass(this.classes.disabled);
    $('[' + this.attr.updateMarketingPreferences + ']').removeAttr(this.attr.disabled);
    $('[' + this.attr.marketingPreferencesChanged + ']').attr('value', true);
  },
  toggleSpecialPreferences: function toggleSpecialPreferences(e) {
    var selectedSpecialPreference = $(e.currentTarget).attr('name');
    var otherSpecialPreferences = $('[' + this.attr.specialPreferenceOption + ']');
    $(otherSpecialPreferences).each(function () {
      if ($(this).attr('name') != selectedSpecialPreference) {
        if ($(this).is(':checked')) {
          $(this).prop('checked', false);
          $(this).val('false');
        }
      }
    });
  },
  showMarketingPreferencesSaveWarningModal: function showMarketingPreferencesSaveWarningModal(e) {
    if ($(this).attr('target') != '_blank') {
      var hasMarketingPreferencesChange = $('[' + this.attr.marketingPreferencesChanged + ']').attr('value');
      if (hasMarketingPreferencesChange != "false" && hasMarketingPreferencesChange != undefined) {
        e.preventDefault();
        var destinationUrl = $(e.currentTarget).attr('href');
        var modalUrl = window.location.origin + "/marketing-preferences-save-warning?destination=" + destinationUrl;
        app.helpers.openModal(modalUrl, "ajax");
      }
    }
  }
});